module.exports = {"id":"223017","name":"Ömer Ali Şahiner","rating":"75","photo":"./data/images/photos/0/223017.png","club":{"name":"Konyaspor","logo":"./data/images/clubs/Konyaspor.png"},"positions":["MD","MG","DG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/OmerAliSahiner0.json
// module id = 3286
// module chunks = 0